import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as legalEntityState from '../static-data.reducer';
import * as legalEntityReducer from '../reducers/legal-entity-type.reducer';

export const selectLegalEntityTypes = createSelector(legalEntityState.selectLegalEntityTypeState, legalEntityReducer.getLegalEntityTypes);
